<div class="ya-error-validaton-container" [ngClass]="controlValidation ? 'ya-input-invalid':'ya-input-valid'">
  <div class="ya-error-validation">
    <div class="error-validation-icon">
      <div class="inline-icon" inlineSVG="shop-icons.svg#ya-close"></div>
    </div>
    <div class="error-validation-text ya-caption"><span [langkey]="errorMessage"></span>
    </div>
  </div>
</div>